import { Injectable } from '@angular/core';
import { HttpServices } from '../../../shared/services/http-service.service';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { AppConfig } from 'src/app/shared/services/app.config';
import { FormGroup } from '@angular/forms';
import { AttachmentType } from 'src/app/shared/models/enums.model';
import { Attachment } from '../models/attachment.model';
import { TranslateService } from '@ngx-translate/core';
@Injectable({ providedIn: 'root' })

export class fileService {
  constructor(private http: HttpServices, private httpClient: HttpClient, private translate: TranslateService) { }

  public IsFileExtentionValid(event): Boolean {
    var isValid: Boolean = false;
    const allowedExtentions = event.target.attributes['accept'].value;
    const file = event.target.files[0];
    const fileName = file.name;
    const lastDot = fileName.lastIndexOf('.');
    const fileExtention = fileName.substring(lastDot);
    isValid = allowedExtentions.includes(fileExtention.toLowerCase());
    return isValid;
  }

  public IsFileSizeValid(event): Boolean {
    var isValid: Boolean = false;
    const maxSizeInMB = parseFloat(event.target.attributes['MaxSizeInMB'].value);
    const file = event.target.files[0];
    const fileSize = file.size;
    const fileSizeInMB = parseFloat((fileSize / (1024 * 1024)).toFixed(2));
    isValid = (fileSizeInMB <= maxSizeInMB);
    return isValid;
  }

  public upload(formData) {

    var apiUrl = AppConfig.settings.apiServer.apiUrl;
    return this.httpClient.post<any>(apiUrl + 'file/Upload', formData, {
      reportProgress: true,
      observe: 'events'
    }
    );
  }


  public fileUploader(formData) {

    var apiUrl = AppConfig.settings.apiServer.apiUrl;
    return this.httpClient.post<any>(apiUrl + 'file/UploadFile', formData, {
      reportProgress: true,
      observe: 'events'
    }
    );
  }

  public fileUploaderForAdmin(formData) {

    var apiUrl = AppConfig.settings.apiServer.apiUrl;
    return this.httpClient.post<any>(apiUrl + 'file/UploadFileForAdmin', formData, {
      reportProgress: true,
      observe: 'events'
    }
    );
  }

  public UploadSelectedFile(currFormGroup: FormGroup, event, baseRequestId,folderName, docName, attachmentType: AttachmentType, progressVariableName, callbackUpload) {
    if (!this.IsFileExtentionValid(event)) {
      var formControlName = event.target.attributes['formControlName'].value;
      currFormGroup.controls[formControlName].setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        alert(res);
        return false;
      });
    }

    if (!this.IsFileSizeValid(event)) {
      var formControlName = event.target.attributes['formControlName'].value;
      currFormGroup.controls[formControlName].setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        alert(res);
        return false;
      });
    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', folderName);
    this.upload(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total)
          this[progressVariableName] = percentDone;
        } else if (event instanceof HttpResponse) {

          var jsonResponse = event.body.Data;
          var Url = jsonResponse.Url;
          var attachment = new Attachment();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          attachment.BaseRequestId = baseRequestId;
          callbackUpload(attachment, progressVariableName);
        }
      }
    );
  }
}
